import React from 'react';

export const LocationPin = ({ color = '#A2A2A2', size = 22 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.0001 8.2C17.0001 13.1182 11.1001 19 10.2001 19C9.30006 19 3.00006 13.1182 3.00006 8.2C3.00006 3.28178 6.13407 1 10.0001 1C13.8661 1 17.0001 3.28178 17.0001 8.2Z"
      stroke="#A2A2A2"
      strokeLinecap="round"
    />
    <ellipse cx="10.0004" cy="8" rx="3.23077" ry="3" stroke={color} strokeLinecap="round" />
  </svg>
);

export const Circle = ({ color = '#A2A2A2', size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="7.99998" cy="7.99999" r="6.66667" stroke={color} strokeLinecap="round" />
  </svg>
);

export const Calender = ({ color = '#A2A2A2', size = 22 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width={size} height={size} fill="#D8D8D8" fillOpacity="0.01" />
    <rect
      x="2.771"
      y="4.23291"
      width="14.0862"
      height="11.6004"
      rx="2"
      stroke={color}
      strokeLinecap="round"
    />
    <path d="M2.97577 7.80077H17.0004" stroke={color} />
    <path d="M6.08537 2.57568V5.8957" stroke={color} strokeLinecap="round" />
    <path d="M13.5428 2.57568V5.8957" stroke={color} strokeLinecap="round" />
    <circle cx="13.5428" cy="12.5188" r="0.828599" fill="#A2A2A2" />
  </svg>
);

export const Person = ({ color = '#A2A2A2', size = 22 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width={size} height={size} fill="#D8D8D8" fillOpacity="0.01" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.1787 16.4382H3.82106C3.74602 16.4382 3.67378 16.4067 3.62282 16.3506C3.5965 16.3219 3.55394 16.2613 3.5601 16.177C3.76786 13.6639 5.39412 11.5294 7.73383 10.652C8.40864 11.0963 9.18145 11.3424 9.99962 11.3424C10.8144 11.3424 11.5934 11.0997 12.271 10.6543C14.6051 11.5328 16.2325 13.6712 16.4391 16.177C16.4459 16.2613 16.4033 16.3219 16.377 16.3506C16.3255 16.4067 16.2532 16.4382 16.1787 16.4382ZM6.40219 7.17113C6.40219 5.181 8.01613 3.5616 10.0002 3.5616C11.9843 3.5616 13.5988 5.181 13.5988 7.17113C13.5988 8.33668 13.0327 9.43706 12.084 10.1139C10.8408 11.0003 9.09583 10.975 7.87109 10.0729L7.80445 10.0328C6.91012 9.33427 6.40219 8.29455 6.40219 7.17113ZM14.1585 7.17124C14.1585 4.87105 12.2932 3 9.99992 3C7.70726 3 5.84187 4.87105 5.84187 7.17124C5.84187 8.36206 6.33972 9.4675 7.21165 10.2578C4.84562 11.2807 3.21824 13.5174 3.00264 16.131C2.98471 16.3518 3.05864 16.5652 3.21096 16.7315C3.36832 16.9017 3.59064 17 3.82137 17H16.179C16.4098 17 16.6321 16.9017 16.7889 16.7315C16.9418 16.5652 17.0157 16.3518 16.9972 16.131C16.7822 13.5258 15.1565 11.2846 12.7944 10.2595C13.6562 9.47368 14.1585 8.35195 14.1585 7.17124Z"
      fill={color}
    />
    <path
      d="M3.62282 16.3506L3.84501 16.149L3.84373 16.1476L3.62282 16.3506ZM3.5601 16.177L3.2611 16.1523L3.2609 16.1551L3.5601 16.177ZM7.73383 10.652L7.89881 10.4015L7.77137 10.3176L7.62849 10.3711L7.73383 10.652ZM12.271 10.6543L12.3767 10.3735L12.2338 10.3197L12.1062 10.4036L12.271 10.6543ZM16.4391 16.177L16.7382 16.1531L16.7381 16.1523L16.4391 16.177ZM16.377 16.3506L16.1561 16.1476L16.1559 16.1478L16.377 16.3506ZM12.084 10.1139L12.2582 10.3582L12.2583 10.3581L12.084 10.1139ZM7.87109 10.0729L8.04901 9.83137L8.03783 9.82313L8.02594 9.81597L7.87109 10.0729ZM7.80445 10.0328L7.61979 10.2692L7.63408 10.2803L7.6496 10.2897L7.80445 10.0328ZM7.21165 10.2578L7.3307 10.5332L7.75824 10.3484L7.41312 10.0355L7.21165 10.2578ZM3.00264 16.131L2.70365 16.1064L2.70362 16.1068L3.00264 16.131ZM3.21096 16.7315L2.98975 16.9342L2.99068 16.9352L3.21096 16.7315ZM16.7889 16.7315L17.0095 16.9348L17.0097 16.9346L16.7889 16.7315ZM16.9972 16.131L16.6982 16.1557L16.6983 16.1561L16.9972 16.131ZM12.7944 10.2595L12.5922 10.0378L12.2497 10.3502L12.6749 10.5347L12.7944 10.2595ZM16.1787 16.1382H3.82106V16.7382H16.1787V16.1382ZM3.82106 16.1382C3.82965 16.1382 3.83843 16.1417 3.845 16.149L3.40063 16.5521C3.50912 16.6717 3.66239 16.7382 3.82106 16.7382V16.1382ZM3.84373 16.1476C3.84644 16.1505 3.84975 16.1546 3.85291 16.1616C3.85676 16.1702 3.86041 16.1837 3.8593 16.1989L3.2609 16.1551C3.24621 16.356 3.34792 16.4948 3.4019 16.5535L3.84373 16.1476ZM3.85908 16.2017C4.05724 13.8047 5.60774 11.7697 7.83917 10.9329L7.62849 10.3711C5.1805 11.2891 3.47848 13.5231 3.26112 16.1523L3.85908 16.2017ZM7.56885 10.9026C8.28989 11.3774 9.1196 11.6424 9.99962 11.6424V11.0424C9.2433 11.0424 8.52739 10.8153 7.89881 10.4015L7.56885 10.9026ZM9.99962 11.6424C10.8752 11.6424 11.7111 11.3813 12.4358 10.905L12.1062 10.4036C11.4757 10.8181 10.7536 11.0424 9.99962 11.0424V11.6424ZM12.1653 10.9351C14.3914 11.7729 15.9431 13.8119 16.1402 16.2017L16.7381 16.1523C16.5219 13.5305 14.8188 11.2927 12.3767 10.3735L12.1653 10.9351ZM16.1401 16.2008C16.1388 16.1852 16.1426 16.1712 16.1466 16.1622C16.1499 16.1548 16.1534 16.1505 16.1561 16.1476L16.5979 16.5535C16.6519 16.4948 16.7543 16.3552 16.7382 16.1531L16.1401 16.2008ZM16.1559 16.1478C16.1611 16.1421 16.169 16.1382 16.1787 16.1382V16.7382C16.3375 16.7382 16.4899 16.6713 16.5981 16.5533L16.1559 16.1478ZM6.70219 7.17113C6.70219 5.34577 8.18274 3.8616 10.0002 3.8616V3.2616C7.84953 3.2616 6.10219 5.01624 6.10219 7.17113H6.70219ZM10.0002 3.8616C11.8178 3.8616 13.2988 5.34583 13.2988 7.17113H13.8988C13.8988 5.01618 12.1509 3.2616 10.0002 3.2616V3.8616ZM13.2988 7.17113C13.2988 8.23983 12.7794 9.24921 11.9098 9.86971L12.2583 10.3581C13.2859 9.62492 13.8988 8.43353 13.8988 7.17113H13.2988ZM11.9099 9.86965C10.7736 10.6798 9.17067 10.6575 8.04901 9.83137L7.69318 10.3145C9.02099 11.2925 10.908 11.3208 12.2582 10.3582L11.9099 9.86965ZM8.02594 9.81597L7.9593 9.77581L7.6496 10.2897L7.71624 10.3299L8.02594 9.81597ZM7.98911 9.79632C7.16707 9.15429 6.70219 8.20154 6.70219 7.17113H6.10219C6.10219 8.38755 6.65317 9.51425 7.61979 10.2692L7.98911 9.79632ZM14.4585 7.17124C14.4585 4.70622 12.4597 2.7 9.99992 2.7V3.3C12.1266 3.3 13.8585 5.03588 13.8585 7.17124H14.4585ZM9.99992 2.7C7.54069 2.7 5.54187 4.70625 5.54187 7.17124H6.14187C6.14187 5.03585 7.87382 3.3 9.99992 3.3V2.7ZM5.54187 7.17124C5.54187 8.44757 6.07612 9.63347 7.01017 10.4801L7.41312 10.0355C6.60332 9.30153 6.14187 8.27656 6.14187 7.17124H5.54187ZM7.0926 9.98246C4.62546 11.049 2.92841 13.3818 2.70365 16.1064L3.30162 16.1557C3.50807 13.653 5.06578 11.5124 7.3307 10.5332L7.0926 9.98246ZM2.70362 16.1068C2.67882 16.4122 2.78209 16.7075 2.98975 16.9342L3.43216 16.5289C3.33518 16.423 3.29061 16.2914 3.30165 16.1553L2.70362 16.1068ZM2.99068 16.9352C3.20405 17.1659 3.50586 17.3 3.82137 17.3V16.7C3.67543 16.7 3.53259 16.6375 3.43123 16.5278L2.99068 16.9352ZM3.82137 17.3H16.179V16.7H3.82137V17.3ZM16.179 17.3C16.4945 17.3 16.7965 17.166 17.0095 16.9348L16.5683 16.5282C16.4677 16.6374 16.3251 16.7 16.179 16.7V17.3ZM17.0097 16.9346C17.2183 16.7078 17.3218 16.412 17.2962 16.106L16.6983 16.1561C16.7096 16.2916 16.6653 16.4227 16.5681 16.5284L17.0097 16.9346ZM17.2962 16.1064C17.072 13.3904 15.3769 11.0532 12.9138 9.98431L12.6749 10.5347C14.9361 11.516 16.4923 13.6613 16.6982 16.1557L17.2962 16.1064ZM12.9965 10.4812C13.9202 9.63898 14.4585 8.437 14.4585 7.17124H13.8585C13.8585 8.2669 13.3922 9.30838 12.5922 10.0378L12.9965 10.4812Z"
      fill={color}
    />
  </svg>
);

export const DownArrow = ({ color = '#008CFF' }) => (
  <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.84437 4.39411C5.92247 4.47222 6.0491 4.47222 6.12721 4.39411L10.2284 0.292893C10.619 -0.0976314 11.2521 -0.097631 11.6426 0.292893C12.0332 0.683418 12.0332 1.31658 11.6426 1.70711L6.69289 6.65685C6.30237 7.04738 5.66921 7.04738 5.27868 6.65685L0.328933 1.70711C-0.0615914 1.31658 -0.0615913 0.683418 0.328933 0.292893C0.719457 -0.097631 1.35262 -0.097631 1.74315 0.292893L5.84437 4.39411Z"
      fill={color}
    />
  </svg>
);

export const UpArrow = ({ color = '#008CFF' }) => (
  <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.15563 2.60589C6.07753 2.52778 5.9509 2.52778 5.87279 2.60589L1.77157 6.70711C1.38105 7.09763 0.747882 7.09763 0.357358 6.70711C-0.0331669 6.31658 -0.0331669 5.68342 0.357358 5.29289L5.30711 0.343146C5.69763 -0.0473785 6.33079 -0.0473788 6.72132 0.343146L11.6711 5.29289C12.0616 5.68342 12.0616 6.31658 11.6711 6.70711C11.2805 7.09763 10.6474 7.09763 10.2569 6.70711L6.15563 2.60589Z"
      fill={color}
    />
  </svg>
);

export const RightArrow = () => (
  <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.75813 6.50549C4.79563 6.46798 4.81671 6.41711 4.81671 6.36407C4.81671 6.31102 4.79563 6.26015 4.75813 6.22265L0.656909 2.12143C0.469372 1.93389 0.364016 1.67954 0.364016 1.41432C0.364016 1.1491 0.469373 0.894748 0.656909 0.707212C0.844446 0.519676 1.0988 0.414319 1.36402 0.414319C1.62923 0.414319 1.88359 0.519676 2.07112 0.707212L7.02087 5.65696C7.20841 5.8445 7.31376 6.09885 7.31376 6.36407C7.31376 6.62928 7.20841 6.88364 7.02087 7.07117L2.07112 12.0209C1.88358 12.2085 1.62923 12.3138 1.36401 12.3138C1.0988 12.3138 0.844443 12.2085 0.656907 12.0209V12.0209C0.469371 11.8334 0.364014 11.579 0.364014 11.3138C0.364014 11.0486 0.469371 10.7942 0.656907 10.6067L4.75813 6.50549Z"
      fill="#008CFF"
    />
  </svg>
);

export const Trash = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect opacity="0.01" width="24" height="24" fill="#D8D8D8" fillOpacity="0.01" />
    <path d="M4.80759 7.28394H19.2135" stroke="black" strokeLinecap="round" />
    <path
      d="M9 5.75C9 4.64543 9.89543 3.75 11 3.75H13C14.1046 3.75 15 4.64543 15 5.75V7.28397H9V5.75Z"
      stroke="black"
      strokeLinecap="round"
    />
    <path d="M10.3674 10.8232V15.5271" stroke="black" strokeLinecap="round" />
    <path d="M13.3674 10.8232V15.5271" stroke="black" strokeLinecap="round" />
    <path
      d="M6 7.28247H18V18.0325C18 19.137 17.1046 20.0325 16 20.0325H8C6.89543 20.0325 6 19.137 6 18.0325V7.28247Z"
      stroke="black"
      strokeLinecap="round"
    />
  </svg>
);

export const Flight = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="20" height="20" fill="#D8D8D8" fillOpacity="0.01" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.60036 7.48294L9.40056 8.87446L11.5526 7.78168L7.94976 6.80355C7.82964 6.76923 7.70718 6.78561 7.60032 6.84567L6.59802 7.39869L6.60036 7.48294ZM9.40367 9.74718L6.25325 8.18093C5.97635 8.04287 5.80085 7.76519 5.79461 7.45709C5.78837 7.14899 5.95139 6.86507 6.22127 6.71609L7.22357 6.16307C7.50905 6.00395 7.84055 5.96495 8.15489 6.05075L13.7124 7.55927L9.40367 9.74718Z"
      fill="#A2A2A2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4806 12.0143L11.0274 15.1655L11.0961 15.2147L12.4057 14.5361C12.5141 14.4799 12.5976 14.384 12.6374 14.267L13.7309 11.104L11.4806 12.0143ZM11.0746 16.0001C10.9069 16.0001 10.7392 15.9494 10.5965 15.8472C10.3422 15.6678 10.2112 15.3636 10.2556 15.0547L10.7728 11.4597L15.0277 9.73743L13.3756 14.522C13.2688 14.8285 13.0527 15.0797 12.7649 15.2286L11.4545 15.9072C11.3351 15.9696 11.2041 16.0001 11.0746 16.0001Z"
      fill="#A2A2A2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.16807 11.4591L3.72804 13.6329C3.98544 13.8506 4.338 13.9083 4.65 13.7835L18.2431 8.38587C18.6058 8.24001 18.8889 7.94439 19.0169 7.57389C19.1456 7.20261 19.1066 6.79467 18.91 6.45459C18.5528 5.83683 17.7727 5.60439 17.1363 5.92107L4.7202 12.1338L2.86926 10.8195L1.18367 11.378L1.16807 11.4591ZM4.31333 14.6281C3.92099 14.6281 3.53411 14.4916 3.22366 14.2272L0.663699 12.0533C0.433599 11.8583 0.329859 11.5658 0.385239 11.2702C0.441399 10.9738 0.644199 10.739 0.9289 10.6407L2.57236 10.0768C2.82196 9.9902 3.1012 10.0292 3.3196 10.1829L4.78991 11.2273L16.7863 5.22361C17.7925 4.72207 19.0218 5.09101 19.5842 6.06445C19.8946 6.60031 19.9563 7.24381 19.7535 7.82881C19.5507 8.41382 19.1053 8.88026 18.5312 9.10958L4.93811 14.508C4.73531 14.5891 4.52393 14.6281 4.31333 14.6281Z"
      fill="#A2A2A2"
    />
  </svg>
);

export const Copy = () => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    fill="#ffffff"
    height="30"
    viewBox="0 0 64 64"
    enableBackground="new 0 0 64 64"
  >
    <g id="Text-files">
      <path
        d="M53.9791489,9.1429005H50.010849c-0.0826988,0-0.1562004,0.0283995-0.2331009,0.0469999V5.0228
		C49.7777481,2.253,47.4731483,0,44.6398468,0h-34.422596C7.3839517,0,5.0793519,2.253,5.0793519,5.0228v46.8432999
		c0,2.7697983,2.3045998,5.0228004,5.1378999,5.0228004h6.0367002v2.2678986C16.253952,61.8274002,18.4702511,64,21.1954517,64
		h32.783699c2.7252007,0,4.9414978-2.1725998,4.9414978-4.8432007V13.9861002
		C58.9206467,11.3155003,56.7043495,9.1429005,53.9791489,9.1429005z M7.1110516,51.8661003V5.0228
		c0-1.6487999,1.3938999-2.9909999,3.1062002-2.9909999h34.422596c1.7123032,0,3.1062012,1.3422,3.1062012,2.9909999v46.8432999
		c0,1.6487999-1.393898,2.9911003-3.1062012,2.9911003h-34.422596C8.5049515,54.8572006,7.1110516,53.5149002,7.1110516,51.8661003z
		 M56.8888474,59.1567993c0,1.550602-1.3055,2.8115005-2.9096985,2.8115005h-32.783699
		c-1.6042004,0-2.9097996-1.2608986-2.9097996-2.8115005v-2.2678986h26.3541946
		c2.8333015,0,5.1379013-2.2530022,5.1379013-5.0228004V11.1275997c0.0769005,0.0186005,0.1504021,0.0469999,0.2331009,0.0469999
		h3.9682999c1.6041985,0,2.9096985,1.2609005,2.9096985,2.8115005V59.1567993z"
      />
      <path
        d="M38.6031494,13.2063999H16.253952c-0.5615005,0-1.0159006,0.4542999-1.0159006,1.0158005
		c0,0.5615997,0.4544001,1.0158997,1.0159006,1.0158997h22.3491974c0.5615005,0,1.0158997-0.4542999,1.0158997-1.0158997
		C39.6190491,13.6606998,39.16465,13.2063999,38.6031494,13.2063999z"
      />
      <path
        d="M38.6031494,21.3334007H16.253952c-0.5615005,0-1.0159006,0.4542999-1.0159006,1.0157986
		c0,0.5615005,0.4544001,1.0159016,1.0159006,1.0159016h22.3491974c0.5615005,0,1.0158997-0.454401,1.0158997-1.0159016
		C39.6190491,21.7877007,39.16465,21.3334007,38.6031494,21.3334007z"
      />
      <path
        d="M38.6031494,29.4603004H16.253952c-0.5615005,0-1.0159006,0.4543991-1.0159006,1.0158997
		s0.4544001,1.0158997,1.0159006,1.0158997h22.3491974c0.5615005,0,1.0158997-0.4543991,1.0158997-1.0158997
		S39.16465,29.4603004,38.6031494,29.4603004z"
      />
      <path
        d="M28.4444485,37.5872993H16.253952c-0.5615005,0-1.0159006,0.4543991-1.0159006,1.0158997
		s0.4544001,1.0158997,1.0159006,1.0158997h12.1904964c0.5615025,0,1.0158005-0.4543991,1.0158005-1.0158997
		S29.0059509,37.5872993,28.4444485,37.5872993z"
      />
    </g>
  </svg>
);

export const Cross = () => (
  <svg
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="-30 -30 150 150"
    fill="#AEAEAE"
  >
    <g>
      <path
        d="M55.931,47.463L94.306,9.09c0.826-0.827,0.826-2.167,0-2.994L88.833,0.62C88.436,0.224,87.896,0,87.335,0
 c-0.562,0-1.101,0.224-1.498,0.62L47.463,38.994L9.089,0.62c-0.795-0.795-2.202-0.794-2.995,0L0.622,6.096
 c-0.827,0.827-0.827,2.167,0,2.994l38.374,38.373L0.622,85.836c-0.827,0.827-0.827,2.167,0,2.994l5.473,5.476
 c0.397,0.396,0.936,0.62,1.498,0.62s1.1-0.224,1.497-0.62l38.374-38.374l38.374,38.374c0.397,0.396,0.937,0.62,1.498,0.62
 s1.101-0.224,1.498-0.62l5.473-5.476c0.826-0.827,0.826-2.167,0-2.994L55.931,47.463z"
      />
    </g>
  </svg>
);

export const PlusIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.612 0V5.124H11.496V6.744H6.612V11.904H4.86V6.744H0V5.124H4.86V0H6.612Z"
      fill="#4A4A4A"
    />
  </svg>
);
export const Star = ({ color = '#FFCE17' }) => (
  <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.04594 8.42016L1.92738 10.0518L2.52297 6.59592L0 4.14846L3.48666 3.64426L5.04594 0.5L6.60522 3.64426L10.0919 4.14846L7.5689 6.59592L8.1645 10.0518L5.04594 8.42016Z"
      fill={color}
    />
  </svg>
);

export const MinusIcon = () => (
  <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M0 0H11.5V1.81261H0V0Z" fill="#4A4A4A" />
  </svg>
);
export const CrossInCircle = ({ color = '#4A4A4A', size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.4211 13.4213C14.4933 12.3491 15.2235 10.983 15.5193 9.49585C15.8151 8.00867 15.6633 6.46716 15.083 5.06626C14.5027 3.66535 13.5201 2.46799 12.2593 1.62556C10.9985 0.783138 9.51624 0.333496 7.99992 0.333496C6.4836 0.333496 5.00133 0.783138 3.74055 1.62556C2.47977 2.46799 1.49712 3.66536 0.916846 5.06626C0.336574 6.46716 0.184748 8.00867 0.480568 9.49585C0.776388 10.983 1.50657 12.3491 2.57877 13.4213C4.01767 14.857 5.9673 15.6632 7.99992 15.6632C10.0325 15.6632 11.9822 14.857 13.4211 13.4213ZM4.70009 10.3572L6.93926 8.11801C6.97052 8.08676 6.98808 8.04436 6.98808 8.00016C6.98808 7.95596 6.97052 7.91357 6.93926 7.88231L4.70009 5.64314C4.57507 5.51812 4.50483 5.34855 4.50483 5.17174C4.50483 4.99492 4.57507 4.82535 4.70009 4.70033C4.82511 4.57531 4.99468 4.50507 5.17149 4.50507C5.34831 4.50507 5.51788 4.57531 5.6429 4.70033L7.88207 6.9395C7.91333 6.97076 7.95572 6.98832 7.99992 6.98832C8.04412 6.98832 8.08652 6.97076 8.11777 6.9395L10.3569 4.70033C10.482 4.57531 10.6515 4.50507 10.8283 4.50507C11.0052 4.50507 11.1747 4.57531 11.2998 4.70033C11.4248 4.82535 11.495 4.99492 11.495 5.17173C11.495 5.34855 11.4248 5.51811 11.2998 5.64314L9.06058 7.88231C9.02933 7.91357 9.01177 7.95596 9.01177 8.00016C9.01177 8.04436 9.02933 8.08676 9.06058 8.11801L11.2998 10.3572C11.4248 10.4822 11.495 10.6518 11.495 10.8286C11.495 11.0054 11.4248 11.175 11.2998 11.3C11.1747 11.425 11.0052 11.4953 10.8283 11.4953C10.6515 11.4953 10.482 11.425 10.3569 11.3L8.11777 9.06082C8.08652 9.02957 8.04412 9.01201 7.99992 9.01201C7.95572 9.01201 7.91333 9.02957 7.88207 9.06082L5.6429 11.3C5.51787 11.425 5.34831 11.4953 5.17149 11.4953C4.99468 11.4953 4.82511 11.425 4.70009 11.3C4.57507 11.175 4.50483 11.0054 4.50483 10.8286C4.50483 10.6518 4.57507 10.4822 4.70009 10.3572Z"
      fill={color}
    />
  </svg>
);

export const ErrorIcon = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="28" height="28" fill="#D8D8D8" />
    <g clipPath="url(#clip0)">
      <path
        className="error-circle"
        d="M14 21C17.866 21 21 17.866 21 14C21 10.134 17.866 7 14 7C10.134 7 7 10.134 7 14C7 17.866 10.134 21 14 21Z"
      />
      <path
        className="error-dot"
        d="M14 16.75C14.7796 16.75 15.4375 16.0921 15.4375 15.3125C15.4375 14.5329 14.7796 13.875 14 13.875C13.2204 13.875 12.5625 14.5329 12.5625 15.3125C12.5625 16.0921 13.2204 16.75 14 16.75Z"
      />
      <path className="error-line" d="M14 12.25V8.75" strokeWidth="1.75" strokeLinecap="round" />
    </g>
  </svg>
);
